import axiosPost from "../../axiosPost";
import { respuestaDe } from "../../respuesta";

/**
 * Alta de un agente. Si la persona ya es agente y está dada de baja, la misma llamada
 * la REACTIVA (realta) y reemplaza sus datos por los que se manden: lo que no viaja
 * queda vacío, igual que en un alta nueva.
 *
 * Todo con `|| null` y nunca `|| ''`: la cadena vacía se graba tal cual.
 *
 * Los LUGARES no se crean acá. Después se asignan con RNHAgenteAsignarDo, y por eso
 * este servicio no tiene función: la función es del lugar, no del agente.
 */
export const RNHAgenteIns = async (credentials, data) => {
  const body = {
    service: "RNHAgenteIns",
    params: {
      // Los tres identifican a la persona y son obligatorios.
      usuarioNroDeDocumentoX: data?.nroDocumento || null,
      usuarioSexo: data?.sexo || null,
      usuarioFechaDeNacimiento: data?.fechaNacimiento || null,

      // Obligatorios tambien, maximo 50 caracteres cada uno.
      usuarioApellidos: data?.apellidos || null,
      usuarioNombres: data?.nombres || null,

      usuarioMail: data?.mail || null,
      // Unico entre TODOS los agentes, incluidos los dados de baja (40019).
      rnhAgenteLegajo: data?.legajo || null,
      rnhAgenteFechaInicio: data?.fechaInicio || null,
      rnhCargoCod: data?.cargoCod || null,
      rnhConvenioCod: data?.convenioCod || null,
      // F (fijo) o R (rotativo). El null es un valor válido: se puede crear el agente
      // sin definirlo y cargárselo después desde Datos laborales.
      rnhAgenteHorarioTipo: data?.horarioTipo || null,

      // Si el titulo exige matricula, va en la MISMA llamada (40017). Y no se manda
      // matricula sin titulo.
      rnhTituloCod: data?.tituloCod || null,
      rnhAgenteMatricula: data?.matricula || null,

      // Hospital del agente. Un agente "Y" sin hospital se puede crear, pero no se le
      // puede asignar ningun lugar hasta cargarselo con Upd.
      rnhHospitalCod: data?.hospitalCod || null,
      // "Y" un solo lugar, "N" varios. Por defecto "N".
      rnhAgenteEstablecimientoUnico: data?.esUnico || null,
    }
  }

  return respuestaDe(await axiosPost(body, credentials));
}
